import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <NFLTemplate
      {...props}
      team="Kansas City Chiefs"
      teamShort="Chiefs"
      teamId={teamIds['Kansas City Chiefs']}
    />
  )
}
